import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from './Button';

export const LinkButton = ({ children, to, ...attrs }) => {
  return (
    <Link to={to}>
      <Button {...attrs}>{children}</Button>
    </Link>
  );
};

LinkButton.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string,
};

LinkButton.defaultProps = {
  children: 'Default button',
  to: '',
};
